import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { StatusBadge } from "../components/StatusBadge";
import { ChevronLeft, Printer } from "lucide-react";
import { formatDate, formatIDR, clientName } from "../lib/format";
import { INVOICE_STATUS_LABEL } from "../lib/constants";

export default function InvoiceDetail() {
  const { id } = useParams();
  const [inv, setInv] = useState(null);

  useEffect(() => { api.get(`/invoices/${id}`).then(({ data }) => setInv(data)); }, [id]);
  if (!inv) return <div className="text-sm text-[#8C9096]">Memuat invoice...</div>;

  return (
    <div className="space-y-6" data-testid="invoice-detail">
      <div className="flex items-center justify-between">
        <Link to="/invoices" className="text-sm text-[#5C6066] hover:text-brand inline-flex items-center gap-1"><ChevronLeft className="w-4 h-4" /> Kembali</Link>
        <Button variant="outline" size="sm" onClick={() => window.open(`/print/invoice/${inv.id}`, "_blank")} data-testid="btn-print-invoice">
          <Printer className="w-4 h-4 mr-1.5" /> Cetak
        </Button>
      </div>

      <Card className="p-6 border border-[#E5E0D8] bg-white shadow-none">
        <div className="flex items-start justify-between flex-wrap gap-2">
          <div>
            <span className="font-mono text-xs text-brand">{inv.invoice_code}</span>
            <h1 className="font-display text-2xl font-bold mt-1">Invoice — {inv.booking?.event_name}</h1>
            <div className="text-sm text-[#5C6066]">{clientName(inv.client)}</div>
          </div>
          <StatusBadge status={inv.status} label={INVOICE_STATUS_LABEL[inv.status]} />
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6 pt-6 border-t border-[#F0EBE0] text-sm">
          <div><div className="text-xs text-[#8C9096]">Tgl Invoice</div><div>{formatDate(inv.invoice_date)}</div></div>
          <div><div className="text-xs text-[#8C9096]">Jatuh Tempo</div><div>{formatDate(inv.due_date)}</div></div>
          <div><div className="text-xs text-[#8C9096]">Termin</div><div>{inv.payment_type}</div></div>
          <div><div className="text-xs text-[#8C9096]">Nominal</div><div className="font-semibold">{formatIDR(inv.amount)}</div></div>
        </div>
        {inv.notes && <div className="mt-4 text-sm text-[#5C6066]">{inv.notes}</div>}
      </Card>

      <Card className="border border-[#E5E0D8] bg-white shadow-none">
        <div className="px-5 py-4 border-b border-[#E5E0D8]"><h2 className="font-display font-semibold">Pembayaran</h2></div>
        <div className="divide-y divide-[#F0EBE0]">
          {(inv.payments || []).length === 0 && <div className="p-6 text-sm text-center text-[#8C9096]">Belum ada pembayaran atas invoice ini.</div>}
          {(inv.payments || []).map((p) => (
            <div key={p.id} className="px-5 py-3 flex justify-between text-sm">
              <div>
                <div>{p.payment_type}</div>
                <div className="text-xs text-[#8C9096]">{formatDate(p.payment_date)} — {p.method}</div>
              </div>
              <div className="font-mono font-semibold">{formatIDR(p.amount)}</div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
